module.exports = __webpack_public_path__ + "static/img/bg.117a682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/mobile/bg.jpg
// module id = 668
// module chunks = 64